<template>
  <fragment>
    <v-container :class="{ 'fixed-width': mdUp }">
      <div class="root mx-2">
        <v-card class="paper" elevation="0">
          <div class="paper-accent-strip"></div>
          <v-row align="center" no-gutters class="pa-6 pa-lg-10">
            <v-col cols="12" md="9">
              <div class="section-kicker-bar mb-3">
                <v-chip small outlined color="primary" class="kicker-chip">
                  <v-icon small left>mdi-rocket-launch-outline</v-icon>
                  {{ $t('contact.ready') }}
                </v-chip>
              </div>
              <h4 class="display-1 pb-2 cta-title">
                {{ $t('contact.ready') }}
              </h4>
              <p class="cta-desc">
                {{ $t('contact.dec') }}
              </p>
            </v-col>
            <v-col cols="12" md="3" class="text-center text-md-right mt-4 mt-md-0">
              <v-btn large color="primary" :to="localePath('/contact')" class="button" depressed>
                <v-icon left>mdi-send</v-icon>
                {{ $t('contact.btn_contact') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </v-container>
  </fragment>
</template>

<style lang="scss" scoped>
@import './action-style.scss';
</style>

<script>
export default {
  computed: {
    mdUp() {
      return this.$mq === 'mdDown' || this.$mq === 'lgDown' || this.$mq === 'xl'
    }
  }
}
</script>
